<template>
	<div>
	   <div class="waga" v-show="show">
		<div class="title"> {{ title }} </div><br/><br/>
		<div class="stitle"> {{ subtitle }} </div>
		<div class="wrap">
    			<ejs-numerictextbox disabled="true" :value="wagaval" format="###.##" :min="0" cssClass="e-style" v-on:change="setAutoWeight($event)" :showSpinButton="false" ></ejs-numerictextbox>
			<label>odczyt wagi (kg)</label>
		</div>
		<div class='wrap'>
    			<ejs-numerictextbox :value="this.wagaReczna" format="###.##" :min="0" cssClass="e-style" :showSpinButton="false" v-on:change="setWeight($event)"></ejs-numerictextbox>
			<label>samodzielne wpisanie wagi (kg)</label>
			<div v-show="showcb">
				<input id="cbwaga" type="checkbox" v-model="valuecb">
				<label for="cbwaga">Zablokuj wagę (na dokumencie zostanie zapisana waga wpisana ręcznie)</label>
			</div>
		</div>
	    </div>
	    <div class="podwaga">
		<div class="wleft">
        		<button class="wlabel"> WRÓĆ </button>
     		</div>
	    </div>
	    <div class="wright">
        		<button class="wlabel commit"> {{ titleCommit }} </button>
		</div>
	</div>
</template>

<script>

import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
import axios from "axios";
import Vue from "vue";
import VueSSE from 'vue-sse';
import Storage from "./Storage";
import * as CONFIG from "./config.js";
import { PdfEllipsePart } from "@syncfusion/ej2-pdf-export/src/implementation/graphics/figures/ellipse-part";

Vue.use(VueSSE);

export default {
  name: "waga",
  components: { 
        "ejs-numerictextbox": NumericTextBoxComponent,
  },
  props: {
    nazwa: String,
    ident: Number,
    dataLoading: Boolean,
    wroc: String,
  },
  data: () => ({
	showcb: false,
	valuecb: false,
	valuecbint: 0,
	title: "",
        subtitle: "POŁÓŻ TOWAR NA WADZE",
	titleCommit: "ZATWIERDŹ",
	urlCheckWeight: "/agent/GALEK.Magazyn/GetSkrzyniaWeight/",
	show: true,
	whereto: "",
	backto: "",
	currentto: "",
	urlPost: "",
	urlGet: "/agent/GALEK.Magazyn/GetPWWeight",
	requestBody: {},
	id_dokumentu_magazynowego: 0,
	idZlecenia: 0,
	skrzynie: "",
	wagaAutomatyczna: 0,
	typ_zlecenia: "",
	wagaReczna: 0,
	wagaTowaru: 0,
	//id_uzytkownika: 300001
	sse: null,
	wagaval: 0,
	id_uzytkownika: -1,
	id_skrzyni: 0,
	ilosc_skrzyni: 0,
	jwt: "",
  }),
  methods: {
	setAutoWeight(e){
		this.wagaAutomatyczna = e.value
	},
	setWeight(e){
		this.wagaReczna = e.value
	},
	wrocclick() {
		this.sse.disconnect();
		this.$router.push({ path: this.backto + this.whereto });
	},
	commitclick() {
		
		this.sse.disconnect();
		
		//alert("Zatwiedź dla user_id:" + this.id_uzytkownika);
		this.currentto = "?prev=waga";
		var id_dok_mag = "";
		var id_zlecenia = "";
		var id_odpadu = "";
		var id_skrzyni = "";
		var skrzyn = "";
		var prev = "";
		var params = this.$route.query;
		if (params["mag"]) {
	     		id_dok_mag = params["mag"];
	     		this.currentto += "&mag=" + id_dok_mag;
		}
		if (params["id_zlecenia"]) {
	     		id_zlecenia = params["id_zlecenia"];
	     		this.currentto += "&id_zlecenia=" + id_zlecenia;
		}
		if (params["id_odpadu"]) {
	     		id_odpadu = params["id_odpadu"];
	     		this.currentto += "&id_odpadu=" + id_odpadu;
		}
		if (params["id_skrzyni"]) {
	     		id_skrzyni = params["id_skrzyni"];
				console.log(id_skrzyni)
	     		this.currentto += "&id_skrzyni=" + id_skrzyni;
		}
		if (params["skrzyn"]) {
	     		skrzyn = params["skrzyn"];
	     		this.currentto += "&skrzyn=" + skrzyn;
		}
        	if (params["prev2"]) {
             		prev = params["prev2"];
	     		this.currentto += "&prev3=" + prev;
		}
		var tempwaga = 0;
		if(this.wagaAutomatyczna === 0 || this.wagaAutomatyczna === null){
			tempwaga = this.wagaReczna
		}
		else{
			tempwaga = this.wagaAutomatyczna
		}
		
		var params = this.$route.query;
		if(params["id_odpadu"]){
			this.getCheckWeight(tempwaga).then(data => {
				var tempdata = data
				this.wagaTowaru = tempdata[0].wagaTowaru
				var params = this.$route.query;
				if(params["id_odpadu"]){
					this.requestBody = {
						id_uzytkownika: this.id_uzytkownika,
						id_artykulu: this.id_odpadu,
						ilosc: 0,
						idZlecenia: this.idZlecenia,
						wagaTowaru: this.wagaTowaru,
						jednostkaPrzyjecia: false,
						dokumenty: this.id_dokumentu_magazynowego
					}
				}else{
					this.requestBody = {
						id_uzytkownika: this.id_uzytkownika,
						id_dokumentu_magazynowego: this.id_dokumentu_magazynowego,
						wagaReczna: this.wagaReczna,
						wagaAutomatyczna: this.wagaAutomatyczna,
						idZlecenia: this.idZlecenia,
						skrzynie: this.skrzynie
					}
				}
				this.postData().then(data => {

					if(data.blad !== "0")
						this.$router.push({ path: "/potwierdzenieerror" + this.currentto + "&prev2=" + this.backto + "&error=" + data.blad});
					else
						this.$router.push({ path: "/potwierdzenieok" + this.currentto + "&prev2=" + this.backto + "&iddokmag=" + data.id_dok});
				});
			})
		}
		else{
			if(this.valuecb === true){
				this.valuecbint = 1
			}else this.valuecbint = 0
			this.requestBody = {
				id_uzytkownika: this.id_uzytkownika,
				id_dokumentu_magazynowego: this.id_dokumentu_magazynowego,
				wagaReczna: this.wagaReczna,
				wagaAutomatyczna: this.wagaAutomatyczna,
				idZlecenia: this.idZlecenia,
				skrzynie: this.skrzynie,
				blokadaWagi: this.valuecbint
			}
			this.postData().then(data => {
				if(data !== "0"){
					if(this.typ_zlecenia==="Magazyn -22"){
						this.$router.push({ path: "/potwierdzenieerror" + this.currentto + "&prev2=" + this.backto + "&error=" + data + "&typ_zlecenia="+  this.typ_zlecenia });
					}
					else{
						this.$router.push({ path: "/potwierdzenieerror" + this.currentto + "&prev2=" + this.backto + "&error=" + data});

					}
				}
				else{
					if(this.typ_zlecenia==="Magazyn -22"){
						this.$router.push({ path: "/potwierdzenieok" + this.currentto + "&prev2=" + this.backto  + "&typ_zlecenia="+  this.typ_zlecenia });

					}
					else 
						this.$router.push({ path: "/potwierdzenieok" + this.currentto + "&prev2=" + this.backto});

				}

			});
		}
	},
	getCheckWeight(tempwaga){
		return axios
			.get(CONFIG.API_URL + this.urlCheckWeight + this.idZlecenia + "/" + this.id_odpadu + "/" + 0 + "/" + 0 + "/" + 0 + "/" + this.id_skrzyni + "/" + this.ilosc_skrzyni + "/" + this.ilosc_skrzyni + "/" + 0 + "/" + tempwaga , {
			headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					"Accept": "application/json",
					"Authorization": "Bearer " +  this.jwt,
			}
			})
			.then(response => {
					return response.data;
			})
			.catch(e => {
					alert("ERROR" + e);
			});
	},
	getData() {
		var tempskrzynie = this.skrzynie.substr(0, this.skrzynie.indexOf(","))
      		return axios
        		.get(CONFIG.API_URL + this.urlGet + "/" + this.id_dokumentu_magazynowego + "/" + tempskrzynie, {
          		headers: {
            			"Content-Type": "application/x-www-form-urlencoded",
            			"Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
          		}
        		})
        		.then(response => {
          			return response.data;
        		})
        		.catch(e => {
          			alert("ERROR" + e);
        		});
				
	},
	postData() {
		return axios
			.post(CONFIG.API_URL + this.urlPost + this.id_uzytkownika, 
			this.requestBody,
			{
				headers: {
						"Content-Type": "application/x-www-form-urlencoded",
						"Accept": "application/json",
						"Authorization": "Bearer " +  this.jwt,
				}
			})
			.then(response => {
					return response.data;
			})
			.catch(e => {
					alert("ERROR" + e);
			});
	},
  },
  mounted() {
	var params = this.$route.query;
        var prev = "";
	var id_dok_mag = "";
	var id_zlecenia = "";
	var id_odpadu = "";
	
	var id_skrzyni = "";
	var skrzyn = "";
        if (params["prev2"]) {
             prev = params["prev2"];
	     this.whereto="?prev=" + prev;
	}
	if (params["mag"]) {
	     id_dok_mag = params["mag"];
		 this.id_dokumentu_magazynowego = id_dok_mag;
	     this.whereto += "&mag=" + id_dok_mag;
	}
	if (params["id_zlecenia"]) {
	     id_zlecenia = params["id_zlecenia"];
		 this.idZlecenia = id_zlecenia;
	     this.whereto += "&id_zlecenia=" + id_zlecenia;
	}
	if (params["id_odpadu"]) {
	     id_odpadu = params["id_odpadu"];
		 this.id_odpadu = id_odpadu;
	     this.whereto += "&id_odpadu=" + id_odpadu;
	}
	if (params["id_skrzyni"]){
		this.skrzynie = params["id_skrzyni"]
     		this.whereto += "&id_skrzyni=" + this.skrzynie;
	}
	if (params["skrzyn"]){
		this.ilosc_skrzyni = params["skrzyn"]
     		this.whereto += "&skrzyn=" + this.ilosc_skrzyni;
	}
	if (params["id_skrzyni"]){
		this.id_skrzyni = params["id_skrzyni"]
	
	}
	if (params["typ_zlecenia"]) {
			this.typ_zlecenia = params["typ_zlecenia"];

        }
	if (params["prev"]) {
		var pp = params["prev"];
		if (pp.indexOf("odpady") != -1) {
			this.title = "ODSORTY > ZLECENIA > ODSORTY > LISTA DOKUMENTÓW PZ > Opakowanie > Waga";
			this.backto = "/odpadyopakowanie";
			this.urlPost = "/agent/GALEK.Magazyn/PrzyjmijDokPW/";
		} else if (pp.indexOf("nosnik") != -1) {
			this.title = " PRZYJĘCIE WYROBU GOTOWEGO > ZLECENIA > LISTA DOKUMENTÓW PZ > Nośnik i Opakowanie > Waga";
			this.backto = "/nosnikopakowanie";
		} else {
			this.title = "WYDANIE Z MAGAZYNU > ZLECENIA > LISTA DOKUMENTÓW PZ > Opakowanie > Waga";
			this.backto = "/opakowanie";
			this.urlPost = "/agent/GALEK.Magazyn/WydajZMagazynu/";
			
			if(params["error"]){
			this.showcb = true
	}
		}
	}

	let that = this;
    	this.$root.$on("update:waga", val1 => {
		if (val1 != null) {
			var vals = new String(val1);
			var ids = vals.split(",");
			//console.log("IDS: " + ids);
			//console.log("IDENT:" + that.ident);
			if (ids.includes("" + that.ident)) {
				console.log("FOUND!");
				that.show = true;
			} else {
				that.show = false;
			}
		}
    	});
	if(this.urlPost === "/agent/GALEK.Magazyn/WydajZMagazynu/"){
		Storage.loadJWT("jwt").then(resp => {
		//alert(resp.access_token);

		that.jwt = resp.access_token;
		that.getData().then(data => {
			that.wagaReczna = data[0].wagaTowaru;
			if(this.typ_zlecenia === "Magazyn -22")
				this.commitclick()
		});

	});
	}

	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
	document.querySelector(".wright").addEventListener('click', function() { that.commitclick(); } );

	this.sse = this.$sse.create(CONFIG.WAGA_URL);
	this.sse.on('message', (msg) => console.log('Message:' + msg))
  		.on('wazenie', (msg) => { console.log('Message:' + msg); var json = JSON.parse(msg); var rand = Math.random() * 10; that.wagaval = json.masa; }) 
  		.on('error', (err) => console.log('Failed to parse or lost connection:' + err))
  		.connect()
  		.catch((err) => console.log('Failed make initial connection:' + err));

        Storage.loadJWT("jwt").then(resp => {
                //alert(resp.access_token);
		that.jwt = resp.access_token;
                that.id_uzytkownika = resp.user_id;
	});
    },
    beforeDestroy() {
	this.sse.disconnect();
    }
	
} 

</script>

<style>

.e-numeric.e-style .e-control.e-numerictextbox {
        color: royalblue;
        font-size: xx-large;
        border: 0px;
    }

/* csslint ignore:start */
    .e-numeric .e-input-group-icon.e-spin-up {
        content: "";
        /*color: rgba(0, 0, 0, 0.54);*/
    }

    .e-numeric .e-input-group-icon.e-spin-down {
        content: "";
        /*color: rgba(0, 0, 0, 0.54);*/
    }
    /* csslint ignore:end */

.waga {
	margin-bottom:5%;
}
.podwaga {
	clear:both;
	margin-top: 30px;
}
.commit {
	width: 200px;
	height: 50px;
}

.nazwa {
}
.title {
        text-align: left;
        width: 100%;
}
.stitle {
	color:red;
}

.wrap {
margin: 5% auto;
width: 240px;
}
.wright {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}

</style>




// WEBPACK FOOTER //
// src/components/Waga.vue